// import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import PopularAttractionActions from '../Redux/PopularAttractionRedux'
import { getToken } from '../Services/GetToken'

export function * getPopularAttraction (api, { data }) {
  // make the call to the api
  yield baseFetchToken(
    api.getPopularAttraction,
    data,
    getToken,
    PopularAttractionActions.popularAttractionSuccess,
    PopularAttractionActions.popularAttractionFailure
  )
}

export function * savePopularAttraction (api, { data }) {
  // make the call to the api
  yield baseFetchToken(
    api.savePopularAttraction,
    data,
    getToken,
    PopularAttractionActions.popularAttractionSaveSuccess,
    PopularAttractionActions.popularAttractionSaveFailure
  )
}

export function * deletePopularAttraction (api, { data }) {
  // make the call to the api
  yield baseFetchToken(
    api.deletePopularAttraction,
    data,
    getToken,
    PopularAttractionActions.popularAttractionDeleteSuccess,
    PopularAttractionActions.popularAttractionDeleteFailure
  )
}

export function * editPopularAttraction (api, { data }) {
  // make the call to the api
  yield baseFetchToken(
    api.editPopularAttraction,
    data,
    getToken,
    PopularAttractionActions.popularAttractionEditSuccess,
    PopularAttractionActions.popularAttractionEditFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/PopularAttractionSagas.js